import { useCallback } from "react";

import { submitBugReportHelper } from "../bug-reporter";

import { useAppSelector } from "store/index";
import {
  selectActiveClassSession,
  selectActivePageIdForCurrentUser,
  selectCurrentClassUser,
  selectCurrentOrgName,
  selectCurrentSectionId,
  selectCurrentUser,
} from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { usePresentation } from "utils/presentation";
import { PROFILE_PROPERTIES } from "utils/user-utils";

export const useBugReporter = () => {
  const orgName = useAppSelector(selectCurrentOrgName);
  const user = useObjectSelector(selectCurrentUser, PROFILE_PROPERTIES);
  const classUser = useAppSelector(selectCurrentClassUser);
  const currentSectionId = useAppSelector(selectCurrentSectionId);
  const classSession = useAppSelector(selectActiveClassSession);
  const activePageId = useAppSelector(selectActivePageIdForCurrentUser);
  const presentationState = usePresentation();

  const submitBugReport = useCallback(
    async (description: string, attachedFiles: File[]) => {
      await submitBugReportHelper({
        description,
        attachedFiles,
        user,
        classUser,
        currentSectionId,
        classSession,
        activePageId,
        presentationState,
        orgName,
        avState: null,
      });
    },
    [activePageId, classSession, classUser, currentSectionId, orgName, presentationState, user],
  );

  return { submitBugReport };
};
